import GameUrlBuilderSelectionGameStepBase from '../../game/game_steps/game_url_builder_selection_gamestep_base';
import GnwpGameUrlBuilder from './gnwp_game_url_builder';

export default class GnwpGameUrlBuilderSelectionGameStep extends GameUrlBuilderSelectionGameStepBase {
    static CLASS = 'GnwpGameUrlBuilderSelectionGameStep';

    init(params) {
        super.init(params);
        if(!params.templateName) {
            this.throwArgumentExpected('10', 'init', 'templateName');
        }

        this._templateName = params.templateName;
        this._getAdditionalParametersCallback = params.getAdditionalParametersCallback;
    }

    run(gameOptions) {
        let additionalParameters = {};

        if(gameOptions.spain && gameOptions.spain.gameLimits) {
            additionalParameters = Object.assign(additionalParameters, {
                requestedGameLimit: gameOptions.spain.gameLimits.RequestedGameLimit,
                requestedTimeLimit: gameOptions.spain.gameLimits.RequestedTimeLimit,
                restrictionPeriod: gameOptions.spain.gameLimits.RestrictionPeriod,
                intervalReminder: gameOptions.spain.gameLimits.IntervalReminderInMinutes
            });
        }

        if(this._getAdditionalParametersCallback) {
            additionalParameters = Object.assign(additionalParameters, this._getAdditionalParametersCallback(gameOptions));
        }



        let urlBuilder = GnwpGameUrlBuilder.create({
            serviceFactory: this.serviceFactory,
            templateName: this._templateName,
            additionalParameters: additionalParameters
        });

        return Promise.resolve(Object.assign(gameOptions, {gameUrlBuilder: urlBuilder}));
    }
}